import { DollarSign, HelpCircle, Trash2, Users } from 'lucide-react';
import type { Contact } from '@/lib/services/contacts/types';
import type { VehicleInstruction } from '@/lib/services/redemption';

export const VEHICLE_INSTRUCTION_LABELS: Record<VehicleInstruction, string> = {
  sell: 'Sell',
  'transfer-to-beneficiary': 'Transfer to Beneficiary',
  'scrap-or-dispose': 'Scrap or Dispose',
  undecided: 'Undecided'
};

export const VEHICLE_INSTRUCTION_ICONS: Record<
  VehicleInstruction,
  typeof DollarSign
> = {
  sell: DollarSign,
  'transfer-to-beneficiary': Users,
  'scrap-or-dispose': Trash2,
  undecided: HelpCircle
};

export const VEHICLE_INSTRUCTION_OPTIONS: VehicleInstruction[] = [
  'sell',
  'transfer-to-beneficiary',
  'scrap-or-dispose',
  'undecided'
];

export interface VehicleTransferBeneficiaryDraft {
  contactId: number;
  contact?: {
    id: number;
    firstName: string;
    lastName: string;
    organisationName?: string | null;
  };
}

export interface VehicleInstructionSectionProps {
  mode: 'read' | 'edit';
  instruction: VehicleInstruction | null | undefined;
  milestoneSummary?: string;
  transferBeneficiaries?: VehicleTransferBeneficiaryDraft[];
  hasContraryIntention?: boolean;
  hasLinkedLoan?: boolean;
  contacts?: Contact[];
  onInstructionChange?: (instruction: VehicleInstruction | null) => void;
  onTransferBeneficiariesChange?: (
    beneficiaries: VehicleTransferBeneficiaryDraft[]
  ) => void;
  onContraryIntentionChange?: (value: boolean) => void;
}
